<template>
    <div>
    <div v-if="accepted" class="app flex-row align-items-center">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <div class="card-group">
                        <div class="card p-4">
                            <div class="card-body">
                                <h1>Aanmelden</h1>
                                <p class="text-muted"><br />Meld je aan met je e-mailadres</p>
                                <div class="form-group">
                                    <b-input-group left="<i class='fa fa-user'></i>">
                                        <b-form-input type="email" placeholder="Account" v-model="user.account" name="account" v-validate="'required|email'" :class="{'form-control': true, 'is-invalid': errors.has('account') }"></b-form-input>
                                    </b-input-group>
                                    <span class="small text-danger" v-show="errors.has('account')">Vul je account (e-mailadres) in</span>
                                </div>
                                <div class="form-group">
                                    <b-input-group left="<i class='fa fa-unlock-alt'></i>">
                                        <b-form-input type="password" placeholder="Wachtwoord" v-model="user.password" name="password" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('password') }"></b-form-input>
                                    </b-input-group>
                                    <span class="small text-danger" v-show="errors.has('password')">Vul je wachtwoord in</span>
                                </div>
                                <div class="row"><br /></div>
                                <div class="row">
                                    <div class="col-6">
                                        <button type="button" class="btn btn-primary px-4" @click="login">Aanmelden</button>
                                    </div>
                                    <div class="col-6 text-right">
                                        <router-link :to="'/pages/vergeten'">Wachtwoord vergeten?</router-link>
                                    </div>
                                </div>
                                <div class="small text-danger" ><br/><span v-show="fout">Het door jou ingevoerde e-mailadres of wachtwoord is ongeldig</span></div>
                            </div>
                        </div>
                        <div class="card text-white bg-primary py-5 d-md-down-none" style="width:44%">
                            <div class="card-body text-center">
                                <div>
                                    <h2>Belichtingstool</h2>
                                    <br />
                                    <p>{{versie}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <footer>
        <cookie-law theme="base"
                    @accept="accept">
            <div slot-scope="props">
                <div slot="message">
                    <h4>Deze website maakt gebruik van cookies</h4>
                    <p>We gebruiken cookies op onze website om je de best mogelijke ervaring te bieden en je voorkeuren te onthouden. Door op <i>Accepteer</i>, te klikken geef je toestemming voor cookies.</p>
                    <button class="btn btn-primary px-4" @click="props.accept"><span>Accepteer</span></button>
                    <br />&nbsp;<br />
                    <div>Belichtingstool {{versie}} - <a href="http://www.thomasmore.be">Kenniscentrum Energie (KCE) - Thomas More Kempen</a> &copy; 2019-2020</div>
                </div>
            </div>
        </cookie-law>
    </footer>

    </div>

</template>

<script>

import CookieLaw from 'vue-cookie-law';
import api from '../api/afdelingteelt'

export default {
    name: 'Login',
    data () {
        return {
            user: {
                account: process.env.USER,
                password: process.env.WACHTWOORD,
            },
            fout: false,
            accepted: false,
        };
    },
    methods: {
        accept () {
            this.accepted = true;
        },
        login () {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.$store.dispatch('login', this.user).then(() => {
                        this.$router.replace('/home');
                    },
                    () => { this.fout = true; },
                    ).catch(() => {
                    });
                } else {
                    // console.log(this.$validator.errors);
                }
            });
        },
    },
    computed: {
        versie () {
            return process.env.VERSIE;
        },
    },
    components: { CookieLaw },
};
</script>

<style>

    .Cookie--batman {
        background: black;
    }

    .Cookie--batman .Cookie__button {
        background: black;
        color: yellow;
    }

    .Cookie--mytheme div.Cookie__button:hover {
        background: black;
        color: yellow;
    }

    .Cookie--batman .Cookie__message {
            color: yellow;
    }

</style>



// WEBPACK FOOTER //
// src/pages/Login.vue